/**
 * @fileoverview Text Editor Preview Component
 * 
 * Preview component for rendered markdown content
 */

import React, { useMemo } from 'react';

/**
 * Text Editor Preview Component
 * 
 * @param {Object} props - Component props
 * @param {string} props.content - Content to preview
 * @param {Object} props.markdownProcessor - Markdown processor instance
 * @param {string} props.testId - Test ID
 */
const TextEditorPreview = ({ content, markdownProcessor, testId }) => {
  
  /**
   * Process markdown content for preview
   */
  const processedContent = useMemo(() => {
    if (!content) {
      return '<p><em>No content to preview</em></p>';
    }

    try {
      // Use markdown processor if available, otherwise show as plain text
      if (markdownProcessor && markdownProcessor.process) {
        return markdownProcessor.process(content);
      } else {
        // Simple markdown-like processing for basic formatting
        return content
          .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') // Bold
          .replace(/\*(.*?)\*/g, '<em>$1</em>') // Italic
          .replace(/\n\n/g, '</p><p>') // Paragraphs
          .replace(/\n/g, '<br>') // Line breaks
          .replace(/^/, '<p>') // Start paragraph
          .replace(/$/, '</p>'); // End paragraph
      }
    } catch (error) {
      console.warn('Markdown processing error:', error);
      return `<pre>${content}</pre>`;
    }
  }, [content, markdownProcessor]);

  return (
    <div className="text-editor-preview" data-testid={testId}>
      <div className="preview-header">
        <h4>Preview</h4>
      </div>
      <div 
        className="preview-content"
        dangerouslySetInnerHTML={{ __html: processedContent }}
        data-testid={`${testId}-content`}
      />
    </div>
  );
};

export { TextEditorPreview };